import React from "react";
import "swiper/css";
import BannerList from "@/components/admin/cmsmodule/heroBanner/bannerconfig/BannerList.tsx";
import { Banner } from "@/services/banner.service.ts";

interface BannerConfigProps {
  banners: Banner[];
  setEditItemData: React.Dispatch<React.SetStateAction<Banner>>;
  setIsEditingBanner: React.Dispatch<React.SetStateAction<boolean>>;
  setIsCreatingBanner: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
}

const BannerConfig: React.FC<BannerConfigProps> = ({
  banners,
  setEditItemData,
  setIsEditingBanner,
  setIsCreatingBanner,
  refetch,
}) => {
  return (
    <div className={`mt-8`}>
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Banner Configuration</h2>
        <button
          onClick={() => setIsCreatingBanner(true)}
          className="rounded-lg border-2 border-[#79BFFF] px-4 py-2 text-[#79BFFF]"
        >
          Add Banner
        </button>
      </div>

      <BannerList
        banners={banners}
        setEditItemData={setEditItemData}
        setIsEditingBanner={setIsEditingBanner}
        refetch={refetch}
      ></BannerList>
    </div>
  );
};

export default BannerConfig;
